//@ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ClearIcon } from 'sharedComponents/Icons';
import Form from '../Form/Form';

const useStyles = makeStyles((theme) => ({
  icon: {
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& svg': {
      height: 20,
      width: 20,
      // @ts-ignore
      fill: theme.color.grey_dark,
    },
  },
}));

const FormTextInputWithControl = ({
  name,
  label,
  disabled,
  onClear,
  onIconButtonClick,
  showClearButton,
  placeholder,
  icon,
  readOnly,
}) => {
  const classes = useStyles();
  const renderAdditionalIcon = () => {
    return (
      icon && (
        <IconButton
          onClick={onIconButtonClick}
          classes={{ root: classes.icon }}
          data-testid="input-barcode-scanner-button"
        >
          {icon}
        </IconButton>
      )
    );
  };

  const renderInputClearButton = () => {
    return showClearButton ? (
      <IconButton
        // @ts-ignore
        onClick={onClear}
        classes={{ root: classes.icon }}
        data-testid="search-field-clear-value"
      >
        <ClearIcon />
      </IconButton>
    ) : (
      renderAdditionalIcon()
    );
  };

  return (
    <Form.Input
      data-testid="input"
      name={name}
      label={label}
      disabled={disabled}
      readOnly={readOnly}
      placeholder={placeholder}
      InputProps={{
        endAdornment: renderInputClearButton(),
      }}
    />
  );
};

FormTextInputWithControl.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onClear: PropTypes.func,
  showClearButton: PropTypes.bool,
  placeholder: PropTypes.string,
  onIconButtonClick: PropTypes.func,
  icon: PropTypes.element,
  readOnly: PropTypes.bool,
};

FormTextInputWithControl.defaultProps = {
  name: '',
  label: '',
  onClear: () => {},
  showClearButton: false,
  placeholder: '',
  onIconButtonClick: () => {},
  icon: null,
  readOnly: false,
};

export default FormTextInputWithControl;
